import { createFileRoute, Outlet } from "@tanstack/react-router";
import { FileViewerProvider } from "@/components/app/messaging/file-viewer/file-viewer-provider";
import { useOutboxWake } from "@/components/app/messaging/sending/use-outbox-wake";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/messaging")({
  beforeLoad: ({ context }) => guardRoute(context.me, "messaging"),
  component: MessagingLayout,
});

/** Every messaging screen shares one file viewer, so any list of files opens the same way. */
function MessagingLayout() {
  useOutboxWake();
  return (
    <FileViewerProvider>
      <Outlet />
    </FileViewerProvider>
  );
}
